import React from 'react';

var SvgAutomationMajor = function SvgAutomationMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.038.859a1 1 0 0 1 .99-.859h2.265a1 1 0 0 1 .99.859l.371 2.598c.703.268 1.35.646 1.924 1.113l2.438-.979a1 1 0 0 1 1.238.428l1.133 1.962a1 1 0 0 1-.249 1.287l-2.065 1.621a7.034 7.034 0 0 1 0 2.222l2.065 1.621a1 1 0 0 1 .249 1.287l-1.133 1.962a1 1 0 0 1-1.239.428l-2.437-.978a6.995 6.995 0 0 1-1.924 1.112l-.371 2.598a1 1 0 0 1-.99.859h-2.266a1 1 0 0 1-.99-.859l-.37-2.598a6.995 6.995 0 0 1-1.924-1.113l-2.438.979a1 1 0 0 1-1.239-.428l-1.132-1.962a1 1 0 0 1 .248-1.287l2.066-1.621a7.06 7.06 0 0 1 0-2.222l-2.066-1.621a1 1 0 0 1-.248-1.287l1.132-1.962a1 1 0 0 1 1.239-.428l2.438.979a6.993 6.993 0 0 1 1.923-1.113l.372-2.598Zm.74 5.66 4.598 3.065a.5.5 0 0 1 0 .832l-4.599 3.066a.5.5 0 0 1-.777-.416v-6.132a.5.5 0 0 1 .777-.416Z"
  }));
};

export { SvgAutomationMajor as S };
